import { responseHandler } from "@msuite/ui/utils";
import type { PatchDocumentBody } from "@msuite/utils/schemas";
import type { Enums } from "@msuite/utils/types";
import { Documents } from "@/components/documents";
import { client } from "@/hono";
import { useAuth } from "@/hooks/use-auth";

/** Props Interface */
interface OrganizationSettingsWorksitesDocumentsProps {
	worksite: Enums<"attendanceWorksiteType">;
}

export function OrganizationSettingsWorksitesDocuments({
	worksite,
}: OrganizationSettingsWorksitesDocumentsProps) {
	/** Hooks */
	const { organization } = useAuth();

	/** Functions */
	async function handleOnPatchDocument(documentId: string, json: PatchDocumentBody) {
		const response = await client.documents[":documentFilesTable"][":documentId"].$patch({
			param: { documentFilesTable: "organizationWorksiteDocumentFiles", documentId },
			json,
		});
		await responseHandler(response);
	}

	/** Computed */
	// The worksite documents hang off the organisation itself, so filing one asks
	// `update Organization` — whose row is its own organisation, the id in both keys.
	const orgId = organization.orgId;
	const parent = orgId
		? { subject: "Organization" as const, resource: { id: orgId, orgId } }
		: undefined;

	/** Render */
	return (
		<Documents
			documentFilesTable="organizationWorksiteDocumentFiles"
			identifier={organization.orgId!}
			parent={parent}
			query={{
				additionalFields: JSON.stringify({
					worksiteType: worksite,
					type: "risk-assessment",
				}),
			}}
			// The explorer is opened on risk assessments alone, so there is no classification left
			// to choose here — only how long an acknowledgement of one of them holds.
			onPatchDocument={handleOnPatchDocument}
		/>
	);
}
